import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.map.js";
import { useRef } from 'react';
import classnames from 'classnames';
import { QRCode } from 'react-qrcode-logo';
import Colors from "../../Color/Colors";
import { AttributeItem } from "../AttributeItem/AttributeItem";
import { Button } from "../../Button/Button/Button";
import { Coin } from "../../Coin/Coin";
import { Container } from "../../Container/Container/Container";
import { ContainerProvider } from "../../Container/ContainerProvider/ContainerProvider";
import { HorizontalList } from "../../List/HorizontalList/HorizontalList";
import { IconButton } from "../../Button/IconButton/IconButton";
import { Image } from "../../Image/Image/Image";
import { Popup } from "../../Popup/Popup/Popup";
import { ReadMoreLess } from "../../ReadMoreLess/ReadMoreLess";
import { SkeletonIndicator } from "../../Indicator/SkeletonIndicator/SkeletonIndicator";
import { Text } from "../../Text/Text/Text";
import styles from "./FoodMasthead.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var FoodMasthead = function FoodMasthead(_ref) {
  var _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? '' : _ref$alt,
    attributes = _ref.attributes,
    image = _ref.image,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    personalPoints = _ref.personalPoints,
    name = _ref.name,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? '' : _ref$description,
    _ref$descriptionReadM = _ref.descriptionReadMore,
    descriptionReadMore = _ref$descriptionReadM === void 0 ? '' : _ref$descriptionReadM,
    _ref$descriptionReadL = _ref.descriptionReadLess,
    descriptionReadLess = _ref$descriptionReadL === void 0 ? '' : _ref$descriptionReadL,
    _ref$coinServingText = _ref.coinServingText,
    coinServingText = _ref$coinServingText === void 0 ? '' : _ref$coinServingText,
    _ref$tooltipContent = _ref.tooltipContent,
    tooltipContent = _ref$tooltipContent === void 0 ? '' : _ref$tooltipContent,
    _ref$tooltipLinkText = _ref.tooltipLinkText,
    tooltipLinkText = _ref$tooltipLinkText === void 0 ? '' : _ref$tooltipLinkText,
    _ref$tooltipLink = _ref.tooltipLink,
    tooltipLink = _ref$tooltipLink === void 0 ? '' : _ref$tooltipLink,
    _ref$infoLabel = _ref.infoLabel,
    infoLabel = _ref$infoLabel === void 0 ? 'Click for more info' : _ref$infoLabel,
    _ref$qrLinkUrl = _ref.qrLinkUrl,
    qrLinkUrl = _ref$qrLinkUrl === void 0 ? '' : _ref$qrLinkUrl,
    _ref$qrLinkUrlLabel = _ref.qrLinkUrlLabel,
    qrLinkUrlLabel = _ref$qrLinkUrlLabel === void 0 ? '' : _ref$qrLinkUrlLabel;
  var popupComponent = useRef(null);
  var togglePopup = function togglePopup() {
    var _popupComponent$curre;
    popupComponent === null || popupComponent === void 0 ? void 0 : (_popupComponent$curre = popupComponent.current) === null || _popupComponent$curre === void 0 ? void 0 : _popupComponent$curre.togglePopup();
  };
  var renderAttributeList = function renderAttributeList(item, key) {
    return /*#__PURE__*/_jsx(AttributeItem, {
      label: item.label,
      value: item.value
    }, key);
  };
  var renderColorCoin = function renderColorCoin(value, secondValue, label) {
    return /*#__PURE__*/_jsx("div", {
      className: styles.coin,
      children: /*#__PURE__*/_jsx(Coin, {
        size: "small",
        value: value,
        secondValue: secondValue,
        label: label
      })
    });
  };
  var renderPersonalPoints = function renderPersonalPoints() {
    var _ref2 = personalPoints || {},
      value = _ref2.value,
      secondValue = _ref2.secondValue,
      label = _ref2.label;
    return renderColorCoin(value, secondValue, label);
  };
  var renderMastheadContent = function renderMastheadContent() {
    if (loading) {
      return /*#__PURE__*/_jsx("div", {
        className: styles.skeletonWrapper,
        children: /*#__PURE__*/_jsx(SkeletonIndicator, {
          barWidths: ['100%', '60%', '78%'],
          size: "xlarge"
        })
      });
    }
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.header,
        "data-e2e-name": "food_masthead_header",
        children: /*#__PURE__*/_jsx(Text, {
          ariaLevel: 1,
          typog: "headline4",
          children: name
        })
      }), personalPoints && typeof personalPoints.value === 'number' && /*#__PURE__*/_jsxs("div", {
        className: styles.coinContainer,
        children: [/*#__PURE__*/_jsx("div", {
          style: {
            display: 'flex',
            flexDirection: 'row'
          },
          children: renderPersonalPoints()
        }), coinServingText !== '' && /*#__PURE__*/_jsxs("div", {
          className: styles.coinDescription,
          children: [/*#__PURE__*/_jsx(Text, {
            typog: "bodycopySmall",
            className: styles.coinDescriptionText,
            children: coinServingText
          }), tooltipContent || tooltipLinkText && tooltipLink ? /*#__PURE__*/_jsxs(Popup, {
            ref: popupComponent,
            handle: /*#__PURE__*/_jsx(IconButton, {
              "aria-label": infoLabel,
              className: styles.coinInfo,
              icon: "info",
              fill: Colors.colorWW740,
              size: "16px",
              onClick: togglePopup
            }),
            children: [/*#__PURE__*/_jsx(Text, {
              typog: "bodycopySmall",
              richText: true,
              children: tooltipContent
            }), tooltipLinkText && tooltipLink && /*#__PURE__*/_jsx("div", {
              className: tooltipContent ? styles.tooltipLink : styles.tooltipLinkNoDesc,
              children: /*#__PURE__*/_jsx(Button, {
                newWindow: true,
                type: "link-quaternary",
                url: tooltipLink,
                children: tooltipLinkText
              })
            })]
          }) : null]
        })]
      }), attributes && /*#__PURE__*/_jsx("div", {
        className: styles.info,
        "data-e2e-name": "food_masthead_detail_info",
        children: /*#__PURE__*/_jsx(HorizontalList, {
          children: attributes.map(renderAttributeList)
        })
      }), description && /*#__PURE__*/_jsx("div", {
        className: styles.description,
        "data-e2e-name": "food_masthead_detail_description",
        children: /*#__PURE__*/_jsx(Text, {
          typog: "bodycopy",
          children: /*#__PURE__*/_jsx(ReadMoreLess, {
            more: descriptionReadMore,
            less: descriptionReadLess,
            children: description
          })
        })
      }), qrLinkUrl && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.qrWrapper,
          children: [/*#__PURE__*/_jsx(QRCode, {
            value: qrLinkUrl,
            style: {
              width: 100,
              height: 100,
              margin: 5
            },
            size: 200
          }), qrLinkUrlLabel && /*#__PURE__*/_jsx("div", {
            className: styles.qrText,
            children: qrLinkUrlLabel
          })]
        }), qrLinkUrlLabel && /*#__PURE__*/_jsx("div", {
          className: styles.appLink,
          children: /*#__PURE__*/_jsx("a", {
            href: qrLinkUrl,
            children: qrLinkUrlLabel
          })
        })]
      })]
    });
  };
  return /*#__PURE__*/_jsx("div", {
    className: classnames({
      [styles.withImage]: image
    }),
    "data-e2e-name": "food_masthead",
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.content,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.hero,
        "data-e2e-name": "food_masthead_hero",
        children: image && /*#__PURE__*/_jsx("div", {
          className: styles.heroImageContainer,
          children: /*#__PURE__*/_jsx(Image, {
            src: image,
            alt: alt,
            className: styles.heroImage,
            loading: "eager"
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles.detailWrapper,
        "data-e2e-name": "food_masthead_detail",
        children: /*#__PURE__*/_jsx(ContainerProvider, {
          maxWidth: image ? undefined : '820px',
          children: /*#__PURE__*/_jsx(Container, {
            innerClassName: !description ? styles['food-masthead__detail-container'] : undefined,
            children: /*#__PURE__*/_jsx("div", {
              className: styles.detail,
              children: renderMastheadContent()
            })
          })
        })
      })]
    })
  });
};